import * as React from "react";
import { ShopPageIndicator } from "../../shop/components/ShopPageIndicator";
export var PageIndicators = function (_a) {
    var currentPage = _a.currentPage, count = _a.count, onPageChange = _a.onPageChange;
    var indicators = new Array(count).fill(1).map(function (_, index) {
        var selected = currentPage === index;
        return (React.createElement(ShopPageIndicator, { onClick: function () { return onPageChange(index); }, key: index, selected: selected, pageIdx: index }));
    });
    return React.createElement("div", { className: "page-indicators" }, indicators);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/slideshow/PageIndicators.tsx
// module id = 2906
// module chunks = 3